<nb-card class="edit-dialog">
    <nb-card-header>
        <p class="primary-header">Filter Output Report by Asset Class</p>

        <button ghost status="basic" nbButton (click)="cancel()">
            <nb-icon icon="close" status="basic"></nb-icon>
        </button>
    </nb-card-header>

    <nb-card-body [nbSpinner]="!(options$ | async)?.length" nbSpinnerSize="medium" nbSpinnerStatus="basic">
        <form>
            <label>
                Select one or more asset classes to include in the Output Report. By default all data will be included.
            </label>
            <label>
                2025-10-17: Downloading filtered report is temporary disabled; only the full report can be retrieved at
                this time.
            </label>

            <!-- TODO: temporarily disabled due to performance problem. -->
            <ngx-select
                class="mb-3"
                [disabled]="true"
                [multiple]="true"
                [formControl]="selectControl"
                [placeholder]="'Select...'"
                [options]="options$ | async"
                [showSelectAll]="true"
            ></ngx-select>

            <div class="btn-container">
                <button nbButton status="basic" (click)="cancel()">
                    <nb-icon icon="close-circle-outline"></nb-icon>
                    Cancel
                </button>

                <button nbButton status="primary" (click)="confirm()">
                    <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
                    Proceed
                </button>
            </div>
        </form>
    </nb-card-body>
</nb-card>
